import { Turbo } from '@hotwired/turbo-rails'
import { Editor } from '../bpmn/editor'

import TurboPower from 'turbo_power'

TurboPower.initialize(Turbo.StreamActions)

document.addEventListener('turbo:frame-load', (event) => {
  event.target.classList.remove('field-errors')
})

// Records that live-update broadcast a page refresh whenever anyone changes them, and Turbo
// applies it by morphing a fresh render of the page over this one. Anything the viewer has
// typed but not sent is absent from that render, so elements marked data-editing — and the
// turbo frame around them, so the read-only version cannot morph in alongside the form —
// veto the morph and keep what is on screen. See test_defects/_comment_composer and
// comments/edit.
//
// Only mark something whose own save path does not go through a morph: the composer is
// replaced by a turbo stream and a comment edit by a frame navigation, but the inline edits
// in application/_inline_fields redirect to the page they are on, and the morph that
// follows is exactly how the form gets replaced by the value just saved.
//
// Turbo's own data-turbo-permanent is not usable for this: a permanent element in the
// document is also carried over into an incoming turbo stream that renders the same id,
// which would stop comments#create from ever resetting the composer.
document.addEventListener('turbo:before-morph-element', (event) => {
  if (event.target.matches('[data-editing], turbo-frame:has([data-editing])')) {
    event.preventDefault()
  }
})

Turbo.StreamActions.bpmn_redraw_element = function () {
  this.targetElements.forEach(targetElement => {
    const editor = Editor.for(targetElement)
    const elementId = this.getAttribute('element_id')
    const element = editor.getElementById(elementId)

    if (!element) {
      console.info(`No BPMN element with id "${elementId}" available in BPMN viewer with id "${editor.container.id}"`)
      return
    }

    const businessProcedureId = this.getAttribute('business_procedure_id')
    const businessProcedureLabel = this.getAttribute('business_procedure_label')
    const procedureArchived = this.getAttribute('procedure_archived') === 'true'

    element.businessObject.set('businessProcedureId', businessProcedureId)
    element.businessObject.set('businessProcedureLabel', businessProcedureLabel)
    element.businessObject.set('procedureArchived', procedureArchived)

    editor.redrawElement(elementId)
    editor.updateArchivedProcedureOverlay(element)
    editor.lint()
  })
}

Turbo.config.forms.confirm = (message, element) => {
  const dialog = document.getElementById('turbo-confirm')
  dialog.querySelector('p').textContent = message
  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener('close', () => {
      resolve(dialog.returnValue === 'confirm')
    }, { once: true })
  })
}
